module.exports = __webpack_public_path__ + "static/img/200149.c2e9fe0b.png";